const axios = require('axios');
const assert = require('assert');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class PaxCoreConnector {

  constructor(configuration) {
    this.httpClient = axios.create(configuration);
  }

  async importBusinessAccount({ payload }) {
    assert(payload, 'payload is required');
    try {
      const { data } = await this.httpClient.post(`/${CURRENT_VERSION}/business-account/import`, payload);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getPassengerList({ payload }) {
    assert(payload, 'payload is required');
    try {
      const { data } = await this.httpClient.get(`/${CURRENT_VERSION}/business-passenger`, {
        params: payload,
      });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getGuestList({ payload }) {
    assert(payload, 'payload is required');
    try {
      const { data } = await this.httpClient.get(`/${CURRENT_VERSION}/business-guest`, {
        params: payload,
      });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async createGuestPassenger({ payload }) {
    assert(payload, 'payload is required');

    try {
      const { data } = await this.httpClient.post(`/${CURRENT_VERSION}/business-guest`, payload);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async updateGuestPassenger({ id, payload }) {
    assert(payload, 'payload is required');

    try {
      const { data } = await this.httpClient.patch(`/${CURRENT_VERSION}/business-guest/${id}`, payload);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async deleteGuestPassenger({ id }) {
    assert(id, 'id is required');

    try {
      const { data } = await this.httpClient.delete(`/${CURRENT_VERSION}/business-guest/${id}`);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    throw errorMapper(error);
  }

}

module.exports = {
  PaxCoreConnector,
};
